export const isCurrentlyResizingElement = (state) => state.getIn(['app', 'resizing', 'isResizing']);
